import { Dropdown } from "@nova/component-dropdown"
import { useState } from "react"
import {
    TopMenuFlyoutEntityData,
    TopMenuFlyoutGroup,
    useTopMenuFlyoutLayerGroups,
} from "./useTopMenuFlyoutLayers"

export function TopBarFlyoutLayers() {
    const groups = useTopMenuFlyoutLayerGroups()
    return (
        <>
            {groups.map((group) => (
                <TopBarFlyoutLayerButton key={group.flyoutId} group={group} />
            ))}
        </>
    )
}

function TopBarFlyoutLayerButton({ group }: { group: TopMenuFlyoutGroup }) {
    const [isOpen, setIsOpen] = useState(false)
    if (!group.entitiesData.length) return null
    return (
        <Dropdown onOpenChange={setIsOpen}>
            <Dropdown.Trigger as="div">
                <group.menuConfig.TriggerComponent
                    entityCount={group.entitiesData.length}
                    open={isOpen}
                />
            </Dropdown.Trigger>
            <Dropdown.Menu unstyled position="bottom-right">
                <group.menuConfig.MenuComponent>
                    {group.entitiesData.map(({ id, plugin }) => (
                        <FlyoutLayerRow key={id} id={id} plugin={plugin} />
                    ))}
                </group.menuConfig.MenuComponent>
            </Dropdown.Menu>
        </Dropdown>
    )
}

function FlyoutLayerRow({ id, plugin }: { id: string; plugin: TopMenuFlyoutEntityData["plugin"] }) {
    const [isHovered, setIsHovered] = useState(false)
    return (
        <div onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
            <plugin.LayerListItem id={id} isHovered={isHovered} />
        </div>
    )
}
